import { PAYMENT_STATUS } from '@/helpers/constants';

export const PAYMENT_STATUS_LABELS = t => ({
  [PAYMENT_STATUS.processed]: t('dynamic:payment_status.processed'),
  [PAYMENT_STATUS.scheduled]: t('dynamic:payment_status.scheduled'),
});
